import { useEffect, useState } from 'react';
import { colors } from '../../lib/theme';
import type { ScreenPhase } from '../../lib/screen-phase';
import { TopNav } from './TopNav';
import { Hero } from './Hero';
import { WaitlistSection } from './WaitlistSection';
import { ScreeningPanel } from './ScreeningPanel';
import { HowItWorks, DataSources } from './DataSources';
import { Footer } from './Footer';

export default function LandingPage() {
  const [phase, setPhase] = useState<ScreenPhase>('input');
  const [newScanNonce, setNewScanNonce] = useState(0);

  useEffect(() => {
    if (process.env.NODE_ENV === 'test') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [phase]);

  function requestNewScan() {
    setNewScanNonce((n) => n + 1);
  }

  return (
    <div
      className="min-h-screen selection:bg-blue-400/20"
      style={{ backgroundColor: colors.bgPrimary, color: colors.textPrimary }}
    >
      <TopNav phase={phase} onNewScan={requestNewScan} onLogoClick={requestNewScan} />
      <main className="mx-auto max-w-page px-6">
        {phase === 'input' && <Hero />}
        <ScreeningPanel
          phase={phase}
          onPhaseChange={setPhase}
          newScanNonce={newScanNonce}
        />
        {phase === 'input' && (
          <>
            <HowItWorks />
            <DataSources />
            <WaitlistSection />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
